import { publicEnvSchema } from './schema';

export const ENV = publicEnvSchema.parse({
  NEXT_PUBLIC_PRIVY_ID: process.env.NEXT_PUBLIC_PRIVY_ID,
  NEXT_PUBLIC_PRIVY_CLIENT_ID: process.env.NEXT_PUBLIC_PRIVY_CLIENT_ID,
  NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID: process.env.NEXT_PUBLIC_WALLETCONNECT_PROJECT_ID,
  NEXT_PUBLIC_REDDIT_PIXEL_ID: process.env.NEXT_PUBLIC_REDDIT_PIXEL_ID,
  NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY,
  NEXT_PUBLIC_HYPERLIQUID_BUILDER_ADDRESS: process.env.NEXT_PUBLIC_HYPERLIQUID_BUILDER_ADDRESS,
  NEXT_PUBLIC_HYPERLIQUID_NETWORK: process.env.NEXT_PUBLIC_HYPERLIQUID_NETWORK,
  NEXT_PUBLIC_LEDGER_API_KEY: process.env.NEXT_PUBLIC_LEDGER_API_KEY,
  NEXT_PUBLIC_AMPLITUDE_API_KEY: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY,
  NEXT_PUBLIC_AMPLITUDE_API_KEY_MIGRATION: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY_MIGRATION,
  NEXT_PUBLIC_AMPLITUDE_MODE: process.env.NEXT_PUBLIC_AMPLITUDE_MODE,
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_TRADE_SURPLUS_RECIPIENT_ADDRESS:
    process.env.NEXT_PUBLIC_TRADE_SURPLUS_RECIPIENT_ADDRESS,
  NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
  NEXT_PUBLIC_VERCEL_URL: process.env.NEXT_PUBLIC_VERCEL_URL,
  NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL: process.env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL,
});
